import { createContext, useContext, useReducer, useRef } from "react"
import SnackBar from "./snackbar"
import { snackbarReducer } from "./reducer"


const SnackBarContext = createContext()

export default function SnackBarProvider({children}) {

    const [snackbars, dispatch] = useReducer(snackbarReducer, [])
    const timeoutRefs = useRef(new Map())

    function add_snackbar(props) {
        const id = Math.random().toString(36).slice(2) + Date.now()
        const text = props['text']

        dispatch({
            'set': 'add',
            'id': id,
            'text': text,
        })

        const timeoutId = setTimeout(() => {
            remove_snackbar({
                id: id
            })
        }, 1000);
        timeoutRefs.current.set(id, timeoutId)
    }

    function remove_snackbar(props) {
        const id = props['id']

        dispatch({
            'set': 'remove',
            'id': id,
        })

        const timeoutId = timeoutRefs.current.get(id)
        if(timeoutId) {
            clearTimeout(timeoutId)
            timeoutRefs.current.delete(id)
        }
    }

    return(
        <SnackBarContext.Provider
            value={{
                add_snackbar
            }}
        >
            {children}

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    zIndex: 1000000,
                    pointerEvents: "none"
                }}
            >
                {snackbars
                .map((value, index) => {
                    return(
                        <SnackBar
                            key={value['id']}
                            {...value}
                            snackbars={snackbars}
                        ></SnackBar>
                    )
                })}
            </div>
        </SnackBarContext.Provider>
    )
}

export function useSnackbar() {
    const context = useContext(SnackBarContext)

    return context
}